import { computed, ref } from "vue";
import { useRouter } from "vue-router";

const mobileSidebarVisible = ref(false);
let attached = false;

export function useBSidebarToggle() {
  if (!attached) {
    attached = true;

    const router = useRouter();
    router?.beforeEach(() => {
      mobileSidebarVisible.value = false;
    });
  }

  return {
    get asRef() {
      return computed(() => mobileSidebarVisible.value)
    },
    get() {
      return mobileSidebarVisible.value
    },
    show() {
      mobileSidebarVisible.value = true;
    },
    hide() {
      mobileSidebarVisible.value = false;
    },
    toggle() {
      mobileSidebarVisible.value = !mobileSidebarVisible.value;
    },
  };
}